import './App.css';
import {useEffect, useState} from "react";


function App() {

    const [betSlips, setBetSlips] = useState([]);
    const [listItems, setListItems] = useState([]);

    const [money, setMoney] = useState(NaN);

    useEffect(() => {
        reload().catch();
        const interval = setInterval(async () => {
            await reload()
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    async function reload() {
        console.debug("Reloading...")
        try {
            const response = await fetch("/api/bet_slips", {
                headers: {
                    "Accept": "application/json",
                }
            });
            const data = await response.json();
            // const data = JSON.parse("[{\"id\":1,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":1,\"match\":{\"id\":1,\"homeTeam\":{\"name\":\"Minnesota Vikings\"},\"awayTeam\":{\"name\":\"New York Jets\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Minnesota Vikings\",\"status\":\"UNKNOWN\"}],\"quote\":1.7,\"stake\":1.82},{\"id\":2,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":2,\"match\":{\"id\":2,\"homeTeam\":{\"name\":\"Chicago Bears\"},\"awayTeam\":{\"name\":\"Carolina Panthers\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Chicago Bears\",\"status\":\"UNKNOWN\"}],\"quote\":1.5,\"stake\":1.82},{\"id\":3,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":3,\"match\":{\"id\":3,\"homeTeam\":{\"name\":\"Houston Texans\"},\"awayTeam\":{\"name\":\"Buffalo Bills\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Buffalo Bills\",\"status\":\"UNKNOWN\"}],\"quote\":1.93,\"stake\":1.82},{\"id\":4,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":4,\"match\":{\"id\":4,\"homeTeam\":{\"name\":\"Jacksonville Jaguars\"},\"awayTeam\":{\"name\":\"Indianapolis Colts\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Indianapolis Colts\",\"status\":\"UNKNOWN\"}],\"quote\":2.3,\"stake\":1.82},{\"id\":5,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":5,\"match\":{\"id\":5,\"homeTeam\":{\"name\":\"New England Patriots\"},\"awayTeam\":{\"name\":\"Miami Dolphins\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Miami Dolphins\",\"status\":\"UNKNOWN\"}],\"quote\":1.83,\"stake\":1.82},{\"id\":6,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":6,\"match\":{\"id\":6,\"homeTeam\":{\"name\":\"Washington Comm.\"},\"awayTeam\":{\"name\":\"Cleveland Browns\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Washington Comm.\",\"status\":\"UNKNOWN\"}],\"quote\":1.6,\"stake\":1.82},{\"id\":7,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":7,\"match\":{\"id\":7,\"homeTeam\":{\"name\":\"San Francisco 49ers\"},\"awayTeam\":{\"name\":\"Arizona Cardinals\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"San Francisco 49ers\",\"status\":\"UNKNOWN\"}],\"quote\":1.27,\"stake\":1.82},{\"id\":8,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":8,\"match\":{\"id\":8,\"homeTeam\":{\"name\":\"Los Angeles Rams\"},\"awayTeam\":{\"name\":\"Green Bay Packers\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Green Bay Packers\",\"status\":\"UNKNOWN\"}],\"quote\":1.6,\"stake\":1.82},{\"id\":9,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":9,\"match\":{\"id\":9,\"homeTeam\":{\"name\":\"Seattle Seahawks\"},\"awayTeam\":{\"name\":\"New York Giants\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Seattle Seahawks\",\"status\":\"UNKNOWN\"}],\"quote\":1.27,\"stake\":1.82},{\"id\":10,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":10,\"match\":{\"id\":10,\"homeTeam\":{\"name\":\"Pittsburgh Steelers\"},\"awayTeam\":{\"name\":\"Dallas Cowboys\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Pittsburgh Steelers\",\"status\":\"UNKNOWN\"}],\"quote\":1.67,\"stake\":1.82},{\"id\":11,\"tipicoId\":\"Betid-15406389375\",\"bets\":[{\"id\":11,\"match\":{\"id\":11,\"homeTeam\":{\"name\":\"Kansas City Chiefs\"},\"awayTeam\":{\"name\":\"New Orleans Saints\"},\"start\":null,\"status\":\"UNKNOWN\"},\"chosenOption\":\"Kansas City Chiefs\",\"status\":\"UNKNOWN\"}],\"quote\":1.37,\"stake\":1.82}]")
            const accountResponse = await fetch("/api/account", {
                headers: {
                    "Accept": "application/json",
                }
            })
            const account = await accountResponse.json();
            setMoney(account.money);
            setBetSlips(data);
        } catch (e) {
            console.error(e);
        }
    }

    function compareBetSlips(a, b) {
        const aStart = a.bets[a.bets.length - 1].match.start;
        const bStart = b.bets[b.bets.length - 1].match.start;

        if (aStart === bStart) { // also applies when both are null
            return a.id - b.id;
        }
        if (aStart === null) {
            return -1;
        }
        if (bStart === null) {
            return 1;
        }
        return new Date(bStart).valueOf() - new Date(aStart).valueOf();
    }

    useEffect(() => {
        const items = betSlips.toSorted((a, b) => compareBetSlips(a, b)).flatMap(betSlip => {
                let date = new Date();
                return <li key={betSlip.id}
                           className={`bet-slip bet-slip-${betSlip.betStatus.toLowerCase()} bet-slip-match-${betSlip.matchStatus.toLowerCase()}`}>
                    <div className={`bets`}>
                        {betSlip.bets.map((bet) => {
                                console.log(date);
                                const singleBet = <div>

                                    {date.valueOf() !== new Date(bet.match.start).valueOf() ?
                                        <div className={`date`}>{new Date(bet.match.start).toLocaleString('de-DE', {
                                            weekday: "long",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            timeZone: 'Europe/Berlin'
                                        })}</div> : ""}

                                    <div
                                        className={`bet bet-${bet.status.toLocaleLowerCase()} bet-match-${bet.match.status.toLocaleLowerCase()}`}>
                                        <span
                                            className={bet.match.homeTeam.name === bet.chosenOption ? "chosen-option" : ""}>{bet.match.homeTeam.name}</span>
                                        &nbsp;-&nbsp;
                                        <span
                                            className={bet.match.awayTeam.name === bet.chosenOption ? "chosen-option" : ""}>{bet.match.awayTeam.name}</span>
                                        &nbsp;{bet.match.homeScore !== null ? '' + bet.match.homeScore + ' - ' + bet.match.awayScore : ''}
                                    </div>
                                </div>;
                                date = new Date(bet.match.start);
                                return singleBet;
                            }
                        )}
                    </div>
                    <div className={`result`}>
                    {betSlip.quote.toFixed(2)} * {betSlip.stake.toFixed(2)} €
                    = {(betSlip.quote * betSlip.stake).toFixed(2)} € &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(
                    -{betSlip.stake.toFixed(2)} € / +{(betSlip.quote * betSlip.stake - betSlip.stake).toFixed(2)} € )
                    </div>
                </li>;
            }
        );
        setListItems(items);
    }, [betSlips]);

    return (
        <div className="App">
            <div id={`header`}>{money.toFixed(2)} €</div>
            <ul>
                {listItems}
            </ul>
        </div>
    );

}

export default App;
